export default __webpack_public_path__ + "static/media/shuimo.cad1c943.png";